import React from "react";
import SidebarDrawer from "./SidebarDrawer";

const Sidebar = ({ children }) => {
  return <SidebarDrawer>{children}</SidebarDrawer>;
};

export default Sidebar;